import React from "react";
import { cn } from "../../lib/utils";

interface ScrollableContentProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The flex-basis value
   * - "basis-40" (10rem) for forms with substantial content
   * - "basis-10" (2.5rem) for standard pages
   * - Custom basis value as string
   */
  basis?: "basis-40" | "basis-10" | string;
}

/**
 * A reusable scrollable content container that handles vertical scrolling
 * and prevents horizontal overflow. Common pattern used across forms and pages.
 */
const ScrollableContent = React.forwardRef<
  HTMLDivElement,
  ScrollableContentProps
>(({ basis = "basis-40", className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "h-full flex-grow flex flex-col overflow-y-auto overflow-x-hidden",
        basis,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

ScrollableContent.displayName = "ScrollableContent";

export default ScrollableContent;
